<template>
	<div id="login">
		<v-app >
			<v-container grid-list-xl text-xs-center>
				<v-layout row wrap>
					<v-flex xs4 offset-xs4>
						<v-card style="padding: 20px; border: 1px; border-radius: 50px;" class="login text-center">
							<v-card-text>
								<img src="" height="48px" class="display-2 font-weight-bold"/>
								<br>
								<v-card-title class="justify-center info--text">Recuperar Senha</v-card-title>
								<v-form>
									enviaremos a orientação para seu email cadastrado!
									<v-text-field 
									clearable
									v-model="user.email_user"
									label="informe seu email"
									prepend-icon="mdi mdi-account"
									type="text"
									color="grey lighten-1"
									>
								</v-text-field>
							</v-form>
							<br>
							<v-btn color="info" block text outlined @click="enviarEmail">Enviar</v-btn>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
	</v-app>
</div>
</template>

<script>
import { baseApiUrl, showError} from '@/global'
import axios from 'axios'
export default {

	name: 'RecoverPass',

	data() {
		return {
			user:{}
		}
	},
	methods: {
		enviarEmail() {
			axios.post(`${baseApiUrl}/recover`, this.user)
			.then(() => {
				this.$toasted.global.defaultSuccess()
				this.$router.push({ path: '/auth' })
			})
			.catch(showError)
		}
	}
};
</script>

<style lang="css" scoped>
</style>
